// extracted by mini-css-extract-plugin
export var animationContainer = "_gj-0";
export var asteriskIcon = "_gj-8";
export var conversationLeftSection = "_gj-4";
export var conversationListItem = "_gj-3";
export var conversationMiddleSection = "_gj-5";
export var conversationRightSection = "_gj-6";
export var detailsContent = "_gj-1";
export var listContainer = "_gj-7";
export var modalContent = "_gj-2";